<div class="asignar-despachos">
  <!-- Filtros: cronograma, estado y día -->
  @if (cronogramas) {
    <section class="filtros">
      <ng-select
        class="filtro-cronograma"
        [items]="cronogramas"
        bindLabel="nombre"
        [(ngModel)]="cronograma"
        placeholder="Cronograma"
        notFoundText="No hay cronogramas disponibles"
        appendTo="body"
        (ngModelChange)="seleccionarCronograma()"
      ></ng-select>

      <ng-select
        class="filtro-estado"
        [items]="estadosFiltro"
        bindValue="valor"
        bindLabel="etiqueta"
        [(ngModel)]="filtro"
        placeholder="Estado"
        notFoundText="Sin resultados"
        appendTo="body"
      ></ng-select>

      @if (cronograma) {
        <div class="filtro-dia">
          <button
            irxBotonIcono
            type="button"
            tooltip="Día anterior"
            (click)="modificarFecha(-1)"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Día</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [ngModel]="fecha"
              readonly
              (dateChange)="parseFecha($event)"
            />
            <button
              irxBotonIcono
              tamano="compacto"
              matIconSuffix
              tooltip="Elegir fecha"
              (click)="picker.open()"
            >
              <mat-icon>calendar_month</mat-icon>
            </button>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <button
            irxBotonIcono
            type="button"
            tooltip="Día siguiente"
            (click)="modificarFecha(1)"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      }
    </section>
  }

  @if (cronograma) {
    <div class="terminal">
      <mat-icon>place</mat-icon>
      <span class="terminal-etiqueta">Terminal</span>
      @if (cronograma?.ubicacion?.identificacion) {
        <span>{{ cronograma?.ubicacion?.identificacion }}</span>
      } @else {
        <span class="no-info">Sin terminal</span>
      }
    </div>

    <!-- Períodos del cronograma -->
    <div class="periodos">
      @for (p of cronograma?.periodos; track $index) {
        @if (
          filtro == null ||
          (checkHora(p) &&
            ((!checkCancelado(p) &&
              ((filtro == 1 && !checkCompletado(p)) ||
                (filtro == 2 && checkCompletado(p)))) ||
              (filtro == 3 && checkCancelado(p)))) ||
          (!checkHora(p) && filtro == 4)
        ) {
          <div
            class="periodo irx-clickeable"
            role="button"
            tabindex="0"
            [class.despachado]="checkHora(p)"
            [class.modificado]="checkHora(p) && p.datos['modificado']"
            [class.selected]="p === periodoSeleccionado"
            (click)="seleccionarPeriodo(p)"
            (keydown.enter)="seleccionarPeriodo(p)"
          >
            <!-- Estado -->
            <div class="periodo-estado">
              @if (checkHora(p)) {
                @if (!checkCancelado(p)) {
                  @if (checkCompletado(p) === true) {
                    <mat-icon class="estado-ok" matTooltip="Completado">
                      check_circle
                    </mat-icon>
                  } @else {
                    <button
                      irxBotonIcono
                      type="button"
                      class="estado-modificado"
                      [tooltip]="
                        p.datos['modificado']
                          ? 'Ver lo programado'
                          : 'Modificado: ver lo despachado'
                      "
                      (click)="clickModificado(p)"
                    >
                      <mat-icon>
                        {{
                          p.datos['modificado'] ? 'arrow_circle_left' : 'cancel'
                        }}
                      </mat-icon>
                    </button>
                  }
                } @else {
                  <mat-icon class="estado-cancelado" matTooltip="Cancelado">
                    error
                  </mat-icon>
                }
              } @else {
                <mat-icon class="estado-pendiente" matTooltip="No despachado">
                  pending
                </mat-icon>
              }
            </div>

            @if (!p.datos['modificado']) {
              <div class="info-periodo info-hora">
                <span>Hora de salida</span>
                <span>{{ p.desde }}</span>
              </div>

              <div class="info-periodo">
                <span>Coche</span>
                @if (completarVehiculo(p.datos['idVehiculo'])) {
                  <span>{{ completarVehiculo(p.datos['idVehiculo']) }}</span>
                } @else {
                  <span class="no-info">Sin vehículo</span>
                }
              </div>

              <div class="info-periodo">
                <span>Chofer</span>
                @if (completarChofer(p.datos['idChofer'])) {
                  <span>{{ completarChofer(p.datos['idChofer']) }}</span>
                } @else {
                  <span class="no-info">Sin chofer</span>
                }
              </div>

              <div class="info-periodo">
                <span>Recorridos</span>
                <span>
                  @for (r of p.datos['idsRecorridos']; track $index) {
                    {{ completarRecorrido(r) }}
                    <br />
                  } @empty {
                    <span class="no-info">Sin recorridos</span>
                  }
                </span>
              </div>
            } @else {
              <div class="info-periodo info-hora">
                <span>Salió</span>
                <span>{{ p.datos['salio'] }}</span>
              </div>

              <div class="info-periodo">
                <span>Coche</span>
                <span>{{ completarVehiculo(p.datos['idVehiculoD']) }}</span>
              </div>

              <div class="info-periodo">
                <span>Chofer</span>
                @if (completarChofer(p.datos['idChoferD'])) {
                  <span>{{ completarChofer(p.datos['idChoferD']) }}</span>
                } @else {
                  <span class="no-info">Sin chofer</span>
                }
              </div>

              <div class="info-periodo">
                <span>Recorridos</span>
                <span>
                  @for (r of p.datos['idsRecorridosD']; track $index) {
                    {{ completarRecorrido(r) }}
                    <br />
                  }
                </span>
              </div>

              <div class="info-periodo">
                <span>Tag recorrido</span>
                <span>{{ p.datos['idRecorridoActual'] }}</span>
              </div>
            }
          </div>
        }
      } @empty {
        <span class="no-info">El cronograma no tiene períodos</span>
      }
    </div>

    <!-- Despacho del período elegido -->
    @if (periodoSeleccionado) {
      <section class="despacho">
        <div class="despacho-titulo">
          <mat-icon>departure_board</mat-icon>
          Despacho de las {{ hora }}
        </div>

        <div class="despacho-campos">
          <mat-form-field class="campo-hora" subscriptSizing="dynamic">
            <mat-label>Sale</mat-label>
            <input
              matInput
              placeholder="12:15"
              [(ngModel)]="hora"
              pattern="^(?:[01]\d|2[0-3]):[0-5]\d$"
              (ngModelChange)="validarDespacho()"
              readonly
              disabled="true"
            />
            <mat-icon matSuffix>schedule</mat-icon>
          </mat-form-field>

          @if (vehiculos) {
            <ng-select
              [items]="vehiculos"
              bindLabel="identificacion"
              bindValue="_id"
              [(ngModel)]="idVehiculo"
              placeholder="Vehículo"
              notFoundText="No hay vehículos disponibles"
              appendTo="body"
              (change)="validarDespacho()"
            ></ng-select>
          }

          @if (choferes) {
            <ng-select
              [(ngModel)]="idChofer"
              notFoundText="No hay choferes disponibles"
              placeholder="Chofer"
              appendTo="body"
              (change)="validarDespacho()"
            >
              @for (c of choferes; track c._id) {
                <ng-option [value]="c._id">
                  {{ c.identificacionInterna }} -
                  {{ c.datosPersonales.nombre }}
                </ng-option>
              }
            </ng-select>
          }

          @if (recorridos) {
            <ng-select
              [items]="recorridos"
              bindLabel="nombre"
              bindValue="_id"
              [(ngModel)]="idsRecorridos"
              placeholder="Recorridos"
              notFoundText="No hay recorridos disponibles"
              appendTo="body"
              [multiple]="true"
              [closeOnSelect]="false"
              (change)="validarDespacho()"
              readonly
            ></ng-select>
          }
        </div>

        <div class="despacho-acciones">
          <button
            irxBoton="secundario"
            type="button"
            (click)="cancelarDespacho()"
          >
            <mat-icon>block</mat-icon>
            Salida cancelada
          </button>
          <button irxBoton="principal" type="button" (click)="crearDespacho()">
            <mat-icon>check</mat-icon>
            Confirmar salida
          </button>
        </div>
      </section>
    }
  } @else if (cronogramas) {
    <p class="no-info vacio">Elegí un cronograma para ver sus salidas</p>
  }
</div>
